import jQuery from 'jquery'
const $ = jQuery
global.jQuery = jQuery
//import _ from 'lodash'
//import Swiper from 'swiper'

import 'jquery-ui'
import 'select2/dist/js/select2.full'
import 'jquery.easing'
global.modaal = require('modaal')
import i18n from '@/i18n.js'

export default {
  mounted() {
    /******/ (function(modules) { // webpackBootstrap
    /******/ 	// The module cache
    /******/ 	var installedModules = {};
    /******/
    /******/ 	// The require function
    /******/ 	function __webpack_require__(moduleId) {
    /******/
    /******/ 		// Check if module is in cache
    /******/ 		if(installedModules[moduleId]) {
    /******/ 			return installedModules[moduleId].exports;
    /******/ 		}
    /******/ 		// Create a new module (and put it into the cache)
    /******/ 		var module = installedModules[moduleId] = {
    /******/ 			i: moduleId,
    /******/ 			l: false,
    /******/ 			exports: {}
    /******/ 		};
    /******/
    /******/ 		// Execute the module function
    /******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ 		// Flag the module as loaded
    /******/ 		module.l = true;
    /******/
    /******/ 		// Return the exports of the module
    /******/ 		return module.exports;
    /******/ 	}
    /******/
    /******/
    /******/ 	// expose the modules object (__webpack_modules__)
    /******/ 	__webpack_require__.m = modules;
    /******/
    /******/ 	// expose the module cache
    /******/ 	__webpack_require__.c = installedModules;
    /******/
    /******/ 	// define getter function for harmony exports
    /******/ 	__webpack_require__.d = function(exports, name, getter) {
    /******/ 		if(!__webpack_require__.o(exports, name)) {
    /******/ 			Object.defineProperty(exports, name, {
    /******/ 				configurable: false,
    /******/ 				enumerable: true,
    /******/ 				get: getter
    /******/ 			});
    /******/ 		}
    /******/ 	};
    /******/
    /******/ 	// getDefaultExport function for compatibility with non-harmony modules
    /******/ 	__webpack_require__.n = function(module) {
    /******/ 		var getter = module && module.__esModule ?
    /******/ 			function getDefault() { return module['default']; } :
    /******/ 			function getModuleExports() { return module; };
    /******/ 		__webpack_require__.d(getter, 'a', getter);
    /******/ 		return getter;
    /******/ 	};
    /******/
    /******/ 	// Object.prototype.hasOwnProperty.call
    /******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
    /******/
    /******/ 	// __webpack_public_path__
    /******/ 	__webpack_require__.p = "";
    /******/
    /******/ 	// Load entry module and return exports
    /******/ 	return __webpack_require__(__webpack_require__.s = 0);
    /******/ })([
    /* 0 */
    /***/ (function(module, exports, __webpack_require__) {

      "use strict";


      __webpack_require__(1);
      
      __webpack_require__(2);
      
      __webpack_require__(3);
      
      __webpack_require__(4);
      
      __webpack_require__(5);
      
      __webpack_require__(6);
      
      __webpack_require__(7);
      
      __webpack_require__(8);
      
      $(document).on('click', '.modaal-gallery-item.is_active img', function () {
        // $('.gallery_main a').modaal('close');
        window.open(this.src, '_blank');
        return false;
      }).on('click', '.j-scroll', function () {
        var id = $(this).attr('href');
        var y = $(id).offset().top;
        $('html, body').animate({ scrollTop: y }, 150, 'easeOutCubic');
        return false;
      }).on('change', '.j-goto', function (e, reset) {
        if (reset) {
          return;
        }
        var url = $(this).val();
        if (url) {
          window.location.href = url;
        }
      });
      
      if (/Version\/10\..+Safari\//i.test(navigator.userAgent)) {
        $('html').addClass('g-html-safari10');
      }
      
      /***/ }),
      /* 1 */
      /***/ (function() {
      
      "use strict";
      
      
      var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
      
      function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
      
      var Item = function () {
        function Item(li, parent) {
          var _this = this;
      
          _classCallCheck(this, Item);
      
          this.class = 'aria-checked';
          this.$btn = $('>a', li);
          this.$target = $(this.$btn.attr('href'));
          this.visible = this.$btn.attr(this.class) === 'true';
          this.$target.toggle(this.visible);
          this.parent = parent;
          this.children = this.$btn.next('ul').children().map(function (i, el) {
            return new Item(el, _this);
          }).get();
          this.$btn.on('click', this.toggle.bind(this)).on('keydown', function (e) {
            if (e.keyCode === 32) {
              _this.$btn.click();
              e.preventDefault();
            }
          });
        }
      
        _createClass(Item, [{
          key: 'toggle',
          value: function toggle() {
            if (this.visible) {
              this.hideAll();
            } else {
              this.showAll();
            }
            return false;
          }
        }, {
          key: 'show',
          value: function show() {
            this.$btn.attr(this.class, true);
            this.visible = true;
            this.$target.show();
            if (this.parent) {
              this.parent.show();
            }
          }
        }, {
          key: 'showAll',
          value: function showAll() {
            this.children.forEach(function (item) {
              return item.showAll();
            });
            this.show();
          }
        }, {
          key: 'hide',
          value: function hide() {
            this.$btn.attr(this.class, false);
            this.visible = false;
            this.$target.hide();
            if (this.parent) {
              this.parent.hideIfNoChildrenVisible();
            }
          }
        }, {
          key: 'hideIfNoChildrenVisible',
          value: function hideIfNoChildrenVisible() {
            var found = this.children.some(function (item) {
              return item.visible;
            });
            if (!found) {
              this.hide();
            }
          }
        }, {
          key: 'hideAll',
          value: function hideAll() {
            this.children.forEach(function (item) {
              return item.hideAll();
            });
            this.hide();
          }
        }]);
      
        return Item;
      }();
      
      $('#submenu > .g-list > li').each(function (i, el) {
        return new Item(el, null);
      });
      
      $(document).on('click', '#submenuBtn[role="button"]', function () {
        var aria = 'aria-expanded';
        var $btn = $(this);
        var $menu = $('#submenu');
        var expanded = $btn.attr(aria) === 'true';
        $menu.slideToggle(function () {
          return $menu.add($btn).attr(aria, !expanded);
        });
        return false;
      });
      
      var mql = window.matchMedia('screen and (max-width: 767px)');
      
      function handleChange(mq) {
        var $btn = $('#submenuBtn');
        var $menu = $('#submenu');
        if (mq.matches) {
          $btn.attr({
            role: 'button',
            'aria-expanded': false,
            'aria-controls': 'submenu'
          });
          $menu.attr({ role: 'region', 'aria-expanded': false });
        } else {
          $btn.removeAttr('role aria-expanded aria-controls');
          $menu.removeAttr('role aria-expanded style');
        }
      }
      
      mql.addListener(handleChange);
      handleChange(mql);
      
      /***/ }),
      /* 2 */
      /***/ (function() {
      
//      "use strict";
      
      
//      var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
      
//      function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
/*      
      var Item = function () {
        function Item(el, manager) {
          _classCallCheck(this, Item);
      
          this.$el = $(el);
          this.$del = $('.searchPanel_del', el);
          this.$del.on('click', manager.delete.bind(manager, this));
          $('.searchPanel_add', el).on('click', manager.add.bind(manager, this));
        }
      
        _createClass(Item, [{
          key: 'disableDel',
          value: function disableDel(disabled) {
            this.$del.attr('disabled', disabled);
          }
        }]);
      
        return Item;
      }();
      
      var Manager = function () {
        function Manager() {
          var _this = this;
      
          _classCallCheck(this, Manager);
      
          this.$el = $('.searchPanel');
          this.items = $('.searchPanel_search', this.$el).map(function (i, el) {
            return new Item(el, _this);
          }).get();
          this.$itemSrc = this.getItemSrc();
        }
      
        _createClass(Manager, [{
          key: 'getItemSrc',
          value: function getItemSrc() {
            var src = this.items[0].$el.clone();
            $('[disabled], [selected]', src).removeAttr('disabled selected');
            $('input:text', src).val('');
            return src;
          }
        }, {
          key: 'add',
          value: function add(src) {
            var $item = this.$itemSrc.clone();
            var item = new Item($item[0], this);
            var index = _.findIndex(this.items, function (o) {
              return o === src;
            });
            this.items.splice(index + 1, 0, item);
            $item.insertAfter(src.$el);
            $('select', $item).select2({ minimumResultsForSearch: Infinity });
            this.disableDel();
          }
        }, {
          key: 'delete',
          value: function _delete(src) {
            var index = _.findIndex(this.items, function (o) {
              return o === src;
            });
            this.items.splice(index, 1);
            src.$el.remove();
            this.disableDel();
          }
        }, {
          key: 'disableDel',
          value: function disableDel() {
            this.items[0].disableDel(this.items.length === 1);
          }
        }]);
      
        return Manager;
      }();
      
      if (document.querySelector('.searchPanel')) {
        new Manager();
      }
*/
      /***/ }),
      /* 3 */
      /***/ (function() {
      
      "use strict";
      
      
      $('.j-select').each(function () {
        var $el = $(this);
        var data = $el.data();
        $el.select2({
          containerCssClass: data.container || '',
          dropdownCssClass: data.dropdown || '',
          minimumResultsForSearch: Infinity,
          placeholder: i18n.t('Form.select')
        });
      });
      
      $('.j-combobox').each(function () {
        var $el = $(this);
      
        function getCurrent() {
          return $('option:selected', $el).data('num');
        }
      
        function gotoOrClear(input) {
          var url = $('[data-num="' + input.value.trim() + '"]', $el).val();
          if (url) {
            window.location.href = url;
          } else {
            input.value = getCurrent();
          }
        }
      
        function formatState(state) {
          if (!state.id) {
            return state.text;
          }
          return $('<input type="text" value="' + state.text + '" aria-hidden="true">').on('focus blur keydown mousedown', function (e) {
            return e.stopPropagation();
          }).on('focus', function () {
            $el.select2('close');
            this.focus();
          }).on('blur', function () {
            if (this.value.trim() !== String(getCurrent())) {
              gotoOrClear(this);
            }
          }).on('keydown', function (e) {
            if (e.keyCode === 13) {
              e.preventDefault();
              gotoOrClear(this);
            }
          });
        }
      
        $el.select2({
          minimumResultsForSearch: Infinity,
          templateSelection: formatState
        });
      });
      
      $(document).on('reset', 'form', function () {
        var $els = $('.j-select, .j-combobox', this);
        setTimeout(function () {
          return $els.trigger('change', [true]);
        }, 0);
      });
      
      /***/ }),
      /* 4 */
      /***/ (function() {
      
      "use strict";
      
      
      //$(document).on('click', '.searchPanel_btn button, .searchPanel_close', function () {
      //  var aria = 'aria-expanded';
      //  var $btn = $('.searchPanel_btn button');
      //  var $title = $('.searchPanel_h span');
      //  var $inner = $('.searchPanel_inner');
      //  var expanded = $btn.attr(aria) === 'true';
      //  var method = expanded ? $inner.slideUp : $inner.slideDown;
      //  $btn.attr(aria, !expanded);
      //  method.call($inner, function () {
      //    $inner.attr(aria, !expanded);
      //    (expanded ? $btn : $title).focus();
      //  });
      //  event.preventDefault()
      //});
      
      // for select2
      //$('.searchPanel-init').removeClass('searchPanel-init');
      
      /***/ }),
      /* 5 */
      /***/ (function() {
      
      "use strict";
      
      
      $(document).on('click', '.db_anchors button', function () {
        var index = $(this).parent().index();
        $('.db_list a').eq(index).click();
        var y = $('#db').offset().top;
        $('html, body').animate({ scrollTop: y }, 300, 'easeOutQuad');
        return false;
      }).on('click', '.db_list a', function () {
        var selected = 'aria-selected';
        var expanded = 'aria-expanded';
        var $el = $(this);
        var id = $el.attr('href');
        $('.db [' + selected + '="true"]').attr(selected, false);
        $('.db [' + expanded + '="true"]').attr(expanded, false);
        $el.attr(selected, true);
        $(id).attr(expanded, true);
        $('h2', id).focus();
        return false;
      }).on('click', '.gallery .swiper-slide a', function () {
        var aria = 'aria-selected';
        var $el = $(this);
        var $context = $el.closest('.gallery');
        var large = $el.data('large');
        var thumb = $el.data('thumb');
        //var src = $el.attr('href');
        var alt = $('img', $el).attr('alt');
        $('[' + aria + '="true"]', $context).attr(aria, false);
        $el.attr(aria, true);

        $('.gallery_main', $context).find('a').attr('href', large).css('background-image', 'none');
        const img = new Image()
        img.onload = () => {
          $('.gallery_main', $context).find('a').attr('href', large).css('background-image', 'url(' + large + ')').find('.g-clip').html(alt);
        }
        img.onerror = () => {
          $('.gallery_main', $context).find('a').attr('href', thumb).css('background-image', 'url(' + thumb + ')').find('.g-clip').html(alt);
        }
        img.src = large;

        return false;
      })
      
      /***/ }),
      /* 6 */
      /***/ (function() {
      
      "use strict";
      
      
      $(document).on('change', '.g-view input:radio', function () {
        var id = $(this).closest('.g-view').data('target');
        $(id).toggleClass('g-itemList-grid', this.value === 'grid');
        $('.g-view[data-target="' + id + '"] input:radio[value="' + this.value + '"]').prop('checked', true);
      });
      
      /***/ }),
      /* 7 */
      /***/ (function() {
      
      "use strict";
      
      
      var selector = '.g-itemList_check input:checkbox';
      
      $(document).on('change', selector, function () {
        $(this).closest('.g-itemList_el').attr('aria-checked', this.checked);
      }).on('reset', 'form', function () {
        var $els = $(selector, this);
        setTimeout(function () {
          return $els.trigger('change', [true]);
        }, 0);
      });
      
      /***/ }),
      /* 8 */
      /***/ (function() {
      
      "use strict";
      
      
      /*
      *   This content is licensed according to the W3C Software License at
      *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
      */
      (function () {
        var tablist = document.querySelectorAll('[role="tablist"]')[0];
      
        if (!tablist) {
          return;
        }
      
        var tabs;
        var panels;
        var delay = determineDelay();
      
        generateArrays();
      
        function generateArrays() {
          tabs = document.querySelectorAll('[role="tab"]');
          panels = document.querySelectorAll('[role="tabpanel"]');
        }
      
        // For easy reference
        var keys = {
          end: 35,
          home: 36,
          left: 37,
          up: 38,
          right: 39,
          down: 40,
          delete: 46
        };
      
        // Add or substract depending on key pressed
        var direction = {
          37: -1,
          38: -1,
          39: 1,
          40: 1
        };
      
        // Bind listeners
        for (var i = 0; i < tabs.length; ++i) {
          addListeners(i);
        }
      
        function addListeners(index) {
          tabs[index].addEventListener('click', clickEventListener);
          tabs[index].addEventListener('keydown', keydownEventListener);
          tabs[index].addEventListener('keyup', keyupEventListener);
      
          // Build an array with all tabs (<button>s) in it
          tabs[index].index = index;
        }
      
        // When a tab is clicked, activateTab is fired to activate it
        function clickEventListener(event) {
          var tab = event.currentTarget;
          activateTab(tab, false);
        }
      
        // Handle keydown on tabs
        function keydownEventListener(event) {
          var key = event.keyCode;
      
          switch (key) {
            case keys.end:
              event.preventDefault();
              // Activate last tab
              activateTab(tabs[tabs.length - 1]);
              break;
            case keys.home:
              event.preventDefault();
              // Activate first tab
              activateTab(tabs[0]);
              break;
      
            // Up and down are in keydown
            // because we need to prevent page scroll >:)
            case keys.up:
            case keys.down:
              determineOrientation(event);
              break;
          }
        }
      
        // Handle keyup on tabs
        function keyupEventListener(event) {
          var key = event.keyCode;
      
          switch (key) {
            case keys.left:
            case keys.right:
              determineOrientation(event);
              break;
            case keys.delete:
              determineDeletable(event);
              break;
          }
        }
      
        // When a tablist’s aria-orientation is set to vertical,
        // only up and down arrow should function.
        // In all other cases only left and right arrow function.
        function determineOrientation(event) {
          var key = event.keyCode;
          var vertical = tablist.getAttribute('aria-orientation') == 'vertical';
          var proceed = false;
      
          if (vertical) {
            if (key === keys.up || key === keys.down) {
              event.preventDefault();
              proceed = true;
            }
          } else {
            if (key === keys.left || key === keys.right) {
              proceed = true;
            }
          }
      
          if (proceed) {
            switchTabOnArrowPress(event);
          }
        }
      
        // Either focus the next, previous, first, or last tab
        // depening on key pressed
        function switchTabOnArrowPress(event) {
          var pressed = event.keyCode;
      
          for (var x = 0; x < tabs.length; x++) {
            tabs[x].addEventListener('focus', focusEventHandler);
          }
      
          if (direction[pressed]) {
            var target = event.target;
            if (target.index !== undefined) {
              if (tabs[target.index + direction[pressed]]) {
                tabs[target.index + direction[pressed]].focus();
              } else if (pressed === keys.left || pressed === keys.up) {
                focusLastTab();
              } else if (pressed === keys.right || pressed == keys.down) {
                focusFirstTab();
              }
            }
          }
        }
      
        // Activates any given tab panel
        function activateTab(tab, setFocus) {
          setFocus = setFocus || true;
          // Deactivate all other tabs
          deactivateTabs();
      
          // Remove tabindex attribute
          tab.removeAttribute('tabindex');
      
          // Set the tab as selected
          tab.setAttribute('aria-selected', 'true');
      
          // Get the value of aria-controls (which is an ID)
          var controls = tab.getAttribute('aria-controls');
      
          // Remove hidden attribute from tab panel to make it visible
          document.getElementById(controls).removeAttribute('hidden');
      
          // Set focus when required
          if (setFocus) {
            tab.focus();
          }
        }
      
        // Deactivate all tabs and tab panels
        function deactivateTabs() {
          for (var t = 0; t < tabs.length; t++) {
            tabs[t].setAttribute('tabindex', '-1');
            tabs[t].setAttribute('aria-selected', 'false');
            tabs[t].removeEventListener('focus', focusEventHandler);
          }
      
          for (var p = 0; p < panels.length; p++) {
            panels[p].setAttribute('hidden', 'hidden');
          }
        }
      
        // Make a guess
        function focusFirstTab() {
          tabs[0].focus();
        }
      
        // Make a guess
        function focusLastTab() {
          tabs[tabs.length - 1].focus();
        }
      
        // Detect if a tab is deletable
        function determineDeletable(event) {
          var target = event.target;
      
          if (target.getAttribute('data-deletable') !== null) {
            // Delete target tab
            deleteTab(event, target);
      
            // Update arrays related to tabs widget
            generateArrays();
      
            // Activate the closest tab to the one that was just deleted
            if (target.index - 1 < 0) {
              activateTab(tabs[0]);
            } else {
              activateTab(tabs[target.index - 1]);
            }
          }
        }
      
        // Deletes a tab and its panel
        function deleteTab(event) {
          var target = event.target;
          var panel = document.getElementById(target.getAttribute('aria-controls'));
      
          target.parentElement.removeChild(target);
          panel.parentElement.removeChild(panel);
        }
      
        // Determine whether there should be a delay
        // when user navigates with the arrow keys
        function determineDelay() {
          var hasDelay = tablist.hasAttribute('data-delay');
          var delay = 0;
      
          if (hasDelay) {
            var delayValue = tablist.getAttribute('data-delay');
            if (delayValue) {
              delay = delayValue;
            } else {
              // If no value is specified, default to 300ms
              delay = 300;
            }
          }
      
          return delay;
        }
      
        //
        function focusEventHandler(event) {
          var target = event.target;
      
          setTimeout(checkTabFocus, delay, target);
        }
      
        // Only activate tab on focus if it still has focus after the delay
        function checkTabFocus(target) {
          var focused = document.activeElement;
      
          if (target === focused) {
            activateTab(target, false);
          }
        }
      })();
      
      /***/ }),
      /* 9 */
      /***/ (function() {

        "use strict";


        function setMediaQueryListListener(sp, pc) {
          var mql = window.matchMedia('screen and (max-width: 767px)');
          var test = function test(e) {
            if (e.matches) {
              sp();
            } else {
              pc();
            }
          };
          mql.addListener(test);
          test(mql);
        }
        
        var swiper = void 0;
        
        function destroySwiper() {
          if (swiper) {
            swiper.destroy();
            swiper = undefined;
          }
        }
        
        //function initSwiperPc(el) {
        //  swiper = new Swiper(el, {
        //    slidesPerView: 5,
        //    spaceBetween: 5,
        //    navigation: {
        //      nextEl: '.areaListArea_next',
        //      prevEl: '.areaListArea_prev'
        //    }
        //  });
        //}
        
        //$('.areaListArea').each(function (i, el) {
        $('.areaListArea').each(function () {
            setMediaQueryListListener(function () {
            destroySwiper();
          }, function () {
            destroySwiper();
            //initSwiperPc(el);
          });
        });
        /***/ })
      /******/ ]);
  }    
};